<template>
  <div>
    <!-- blue edit icon before the role name, as before the tidy-up -->
    <div v-if="!editing" class="flex items-center">
      <button
        type="button"
        class="mr-2 text-brand hover:text-brand-darkest"
        title="Change role"
        v-if="member.id != user.id"
        v-is-authorized="{
          roles: [role],
          permissions: ['can_edit_members', 'can_edit_role'],
        }"
        @click.prevent="startEdit"
      >
        <i class="fa fa-edit"></i>
      </button>
      <span>{{ member.roles[0].title }}</span>
    </div>

    <div v-else class="w-full">
      <multiselect
        v-model="selected"
        :class="{ invalid: errors.has('invite_role') }"
        track-by="id"
        :label="vault_type == 'strata' ? 'title' : 'role'"
        :options="roles"
        :showLabels="false"
        name="invite_role"
        v-validate="'required'"
        :allow-empty="false"
        :searchable="false"
        @input="checkRole"
      ></multiselect>

      <div class="flex mt-2" v-show="set_expiry">
        <flat-pickr
          :config="flatPickrConfig"
          :events="[
            'on-change',
            'on-close',
            'on-destroy',
            'on-key-down',
            'on-month-change',
            'on-open',
            'on-parse-config',
            'on-ready',
            'on-value-update',
          ]"
          class="appearance-none w-full h-10 border rounded px-3 text-black rounded-tr-none rounded-br-none"
          placeholder="Expiry date"
          v-model="expiry"
          name="expiry_date"
          ref="flatPickerExpiry"
        ></flat-pickr>
        <button type="button" class="text-white h-10 px-4 rounded-tr rounded-br bg-brand" data-toggle>
          <i class="fa fa-calendar-alt"></i>
        </button>
      </div>
      <p class="text-red text-sm mt-1" v-if="set_expiry && !expiry && tried">
        Pick an expiry date for this role.
      </p>

      <div class="flex mt-2">
        <button
          type="button"
          class="flex-1 bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark"
          :class="{ 'opacity-50 cursor-not-allowed': saving }"
          :disabled="saving"
          @click.prevent="updateRole"
        >
          <i class="fa fa-spinner fa-spin mr-1" v-if="saving"></i> Save
        </button>
        <button
          type="button"
          class="flex-1 ml-2 border border-grey bg-white text-grey-darker text-sm font-medium py-2 px-4 rounded hover:bg-grey-lightest"
          @click.prevent="cancel"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";

/**
 * Role cell of the Edit/Delete Members page: shows the member's role with a
 * pencil, and in edit mode a role select (plus an expiry date for the
 * time-limited roles) with Save and Cancel. Emits `role-updated`.
 */
export default {
  name: "MemberRole",

  props: ["member", "role", "user", "roles"],

  components: {
    flatPickr,
  },

  data() {
    return {
      editing: false,
      selected: "",
      saving: false,
      tried: false,
      set_expiry: false,
      expiry: null,
      flatPickrConfig: {
        wrap: true,
        allowInput: false,
        dateFormat: "d/m/Y h:i K",
        enableTime: true,
        monthSelectorType: "static",
      },
    };
  },

  methods: {
    startEdit() {
      // start from the member's current role
      const current = this.member.roles[0];
      this.selected = _.find(this.roles, { id: current && current.id }) || "";
      this.set_expiry = false;
      this.expiry = null;
      this.tried = false;
      this.editing = true;
    },

    cancel() {
      this.editing = false;
    },

    checkRole(val) {
      this.expiry = null;
      this.set_expiry = _.includes(["User F", "User G"], _.trim(this.getRoleName(val)));
    },

    getRoleName(role) {
      let vault_id = this.$route.params.vault_id;
      let role_name = role.name;
      let replace_char = vault_id + "-";
      return role_name.replace(replace_char, " ");
    },

    updateRole() {
      this.tried = true;

      if (this.selected == "" || (this.set_expiry && !this.expiry)) {
        return;
      }

      this.saving = true;

      axios
        .patch(`api/vaults/${this.$route.params.vault_id}/users/${this.member.id}/role`, {
          role_id: this.selected.id,
          expiry: this.set_expiry ? this.expiry : null,
        })
        .then(() => {
          this.editing = false;
          this.$noty.success("Role has been updated", { killer: true, timeout: 2000 });
          this.$emit("role-updated");
        })
        .catch(() => {
          this.$noty.error("The role could not be updated", { killer: true, timeout: 4000 });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },

  computed: {
    vault_type() {
      return window.vault_type;
    },
  },
};
</script>
